export default __webpack_public_path__ + "images/SZS.c030311.png";